// 初始化数据
const modals = {
  searchResult: [], //查询结果数据
  searchParams: {}, // 搜索传值
  searchValues: {},
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  action: '', //是否是编辑或者新增
};
export default modals;
